<template>
    <ScreenMessage type="warning" has-user-panel>
        <template #icon>
            <FontAwesomeIcon :icon="faEnvelopeOpen" />
        </template>

        <h3>Verify your e-mail address</h3>
        <p>
            We sent you an email to verify your account.<br>
            <template v-if="canSendVerificationEmail">
                If you do not see an email, please click the button below to send a new one.
            </template>
            <template v-else>
                If you can't find it or the link has expired,
                please ask account administrator to re-send an invite.
            </template>
        </p>

        <template v-if="sending">
            <NewButton color="primary" loading disabled>
                Sending email...
            </NewButton>
        </template>
        <template v-else-if="submitted">
            <NewButton color="secondary" :icon="faCheck" disabled>
                Email sent!
            </NewButton>
        </template>
        <template v-else-if="canSendVerificationEmail">
            <NewButton color="primary" :icon="faSyncAlt" @click="resendMessage">
                Send new verification email
            </NewButton>
        </template>
    </ScreenMessage>
</template>

<script lang="ts">
    import { Component, Vue } from '@evidentid/vue-property-decorator';

    import { faEnvelopeOpen } from '@fortawesome/free-regular-svg-icons';
    import { faSyncAlt, faCheck } from '@fortawesome/free-solid-svg-icons';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

    import NewButton from '@/components/new-button/NewButton.vue';
    import ScreenMessage from '@/components/screen-message/ScreenMessage.vue';
    import { useUserStore } from '@evidentid/dashboard-commons/modules/auth/store/user';

    @Component({
        components: { ScreenMessage, NewButton, FontAwesomeIcon },
    })
    export default class VerifyEmailPage extends Vue {
        private faEnvelopeOpen = faEnvelopeOpen;
        private faSyncAlt = faSyncAlt;
        private faCheck = faCheck;

        private submitted = false;

        private get canSendVerificationEmail(): boolean {
            return Boolean(this.$auth?.canSendVerificationEmail);
        }

        private get sending(): boolean {
            return useUserStore().sendingEmailVerification;
        }

        private async resendMessage(event: Event): Promise<void> {
            event.preventDefault();
            await useUserStore().sendEmailVerification();
            this.submitted = true;
        }

        private async mounted() {
            await useUserStore().refreshSession();
        }
    }
</script>
